import { basisPointsToPercentLabel, formatCents } from 'shared/money';
import { PriceQuoteResponse } from 'store/widget/widget.types';

export interface SummaryBillLine {
  key: string;
  name: string;
  priceText: string;
}

export interface SummaryBillView {
  lines: SummaryBillLine[];
  discountText: string | null;
  showHoldNotice: boolean;
}

export type SummaryBillQuote = Pick<PriceQuoteResponse, 'lineItems' | 'discounts' | 'priceCents'>;

export function getSummaryBillView(quote: SummaryBillQuote | undefined): SummaryBillView {
  if (!quote) {
    return { lines: [], discountText: null, showHoldNotice: false };
  }

  const { totalBasisPoints } = quote.discounts;

  return {
    lines: quote.lineItems.map(({ type, id, name, cents }) => ({
      key: `${type}-${id}`,
      name,
      priceText: type === 'addon' ? `+${formatCents(cents)}` : formatCents(cents),
    })),
    discountText: totalBasisPoints > 0 ? `-${basisPointsToPercentLabel(totalBasisPoints)} %` : null,
    showHoldNotice: quote.priceCents > 0,
  };
}
